import React, { useCallback } from 'react';

import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import BodyRegular from 'components/Typography/BodyRegular';
import { DESSEM_APROVACAO_CINZA_EVENTO } from 'constants/colors';
import useRelatorioAprovacao from 'hooks/Relatorios/Aprovacao/useRelatorioAprovacao';
import { formatarDataBR, rotuloDaDataDoInforme } from 'helper/Relatorios/Aprovacao';

import './index.scss';

/**
 * Estado "vazio" para cliente quando o dia ainda não foi publicado
 * (Figma E). Renderizado pelo `PublicacaoGate` no lugar do `Outlet`.
 */
export default function ClienteNaoPublicado() {
  const { config, status, irParaData } = useRelatorioAprovacao();

  const handleVerUltimoPublicado = useCallback(() => {
    if (status?.ultimo_publicado) irParaData(status.ultimo_publicado);
  }, [irParaData, status]);

  if (!status) return null;

  return (
    <div className="relatorio-aprovacao-cliente-nao-publicado">
      <span className="relatorio-aprovacao-cliente-nao-publicado__icone" aria-hidden="true">
        <Icon iconType="locked" color={DESSEM_APROVACAO_CINZA_EVENTO} />
      </span>
      <SubtitleSemiBold>
        {`Informe de ${rotuloDaDataDoInforme(config, status.data_rodada)} ainda não publicado`}
      </SubtitleSemiBold>
      <BodyRegular>
        Este informe está em revisão pela equipe Ampere e será liberado assim que aprovado.
        Dias sem aprovação aparecem em cinza no calendário.
      </BodyRegular>
      {status.ultimo_publicado && (
        <Button className="relatorio-aprovacao-cliente-nao-publicado__botao" onClick={handleVerUltimoPublicado} small>
          {`Ver informe de ${formatarDataBR(status.ultimo_publicado)}`}
        </Button>
      )}
    </div>
  );
}
